/** Dark teal palette, matching the visual language of the retired
 * `forecasting_risk/AskSyntiro` demo (not imported from it — re-derived here
 * so the demo can be deleted independently at AIC-8). */
export const INK = '#0a3d47';
export const INK_DARK = '#062831';
export const TEAL = '#0ab5a0';
export const SKY = '#3dd6c8';

export const PANEL_GRADIENT = `linear-gradient(180deg, ${INK}, ${INK_DARK})`;
export const SPARK_GRADIENT = `linear-gradient(135deg, ${TEAL}, ${SKY})`;

export const TEXT_PRIMARY = '#eafaf8';
export const TEXT_ANSWER = '#e6f3f3';
export const TEXT_MUTED = '#9fcfcf';
export const TEXT_MUTED_DIM = '#7fb6b9';

export const BORDER_HAIRLINE = 'rgba(255, 255, 255, 0.08)';
export const BORDER_ACCENT = 'rgba(61, 214, 200, 0.3)';

export const USER_BUBBLE_BG = 'rgba(61, 214, 200, 0.14)';
export const USER_BUBBLE_BORDER = 'rgba(61, 214, 200, 0.35)';

export const ERROR_TEXT = '#ff9b9b';
export const ERROR_BG = 'rgba(255, 155, 155, 0.1)';
export const ERROR_BORDER = 'rgba(255, 155, 155, 0.3)';
